import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { Alert, AlertTitle, Snackbar } from "@mui/material";

const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  const [snackBarProps, setSnackBarProps] = useState({});

  const openSnackbar = (props) => {
    setSnackBarProps(props);
  };

  const closeSnackbar = () => {
    setSnackBarProps({});
  };

  // if severity is "error", then autoHideDuration is 0
  const autoHideDuration =
    snackBarProps?.severity === "error"
      ? null
      : snackBarProps?.autoHideDuration || snackBarProps?.timeout || 3000;

  return (
    <SnackbarContext.Provider value={{ openSnackbar, closeSnackbar }}>
      {children}
      <Snackbar
        open={snackBarProps?.open || false}
        autoHideDuration={autoHideDuration}
        onClose={closeSnackbar}
        message={snackBarProps?.message || ""}
        anchorOrigin={{
          vertical: snackBarProps?.position?.vertical || "bottom",
          horizontal: snackBarProps?.position?.horizontal || "right",
        }}
        sx={{ zIndex: 10000 }}>
        <Alert onClose={closeSnackbar} severity={snackBarProps?.severity || "info"}>
          <AlertTitle>{snackBarProps.title}</AlertTitle>
          {snackBarProps.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => useContext(SnackbarContext);

SnackbarProvider.propTypes = {
  children: PropTypes.any,
};
